export const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2S2mwjXMhRrdy5CwbEu9
ge3D/V/4W+R55x7LTyti6ZetuNMxa3Z0YjnHBmE5PazD8EBdW7nanxKCjVVY4Bvk
J4cmKXsY5dW33P3xvepGg5aK6Q/Db2NhAJKMi7F+bziLS8k+/QeNeZs5gVwLQ+UV
94FsE/rQlA3KmYLvihyt/gTqF9njOgzH+wrl+RiJHEdGtoouXypgZfve0EdBog2M
dvobUaWq7IPv9ew6taKDug8SpDnOds7XjgEOwjMNxboPFPtGa2bRRwlXw9872Vtn
FtcRSrylHiW1NjguQXngJXdj3fH34BRaOVlsLkejjNMupuTubYBBiPrmL5wIVyYn
DQIDAQAB
-----END PUBLIC KEY-----`;
